import { Text } from 'bold-ui'
import { information } from 'components/modals/information'
import React from 'react'
import { formatDateAndHoursMinutes } from 'util/date/formatDate'

export const informationRecuperarSenhaDesabilitado = (dataLimiteAlterarSenha: Date) => {
  const dataFormatada = formatDateAndHoursMinutes(dataLimiteAlterarSenha)

  information({
    title: 'Recuperar senha desabilitado',
    body: (
      <Text>
        A senha desse usuário foi redefinida dentro das últimas 24 horas. Será possível recuperar a senha no dia{' '}
        {dataFormatada}.
      </Text>
    ),
    icon: {
      type: 'danger',
      fill: 'alert',
    },
    type: 'normal',
    showCloseButton: true,
    closeLabel: 'Voltar',
  })()
}
